/**
 * jv.Common.MessageBar Module
 * ===========================
 *
 * Show a global message!
 *
 * Usage
 * -----
 *
 * ```
 * $scope.$emit('showMessageBar', {
 *  message: 'the message',
 *  duration: 5000
 *  className: 'class1 class2'
 * });
 * ```
 * or simply
 *
 * ```
 * $scope.$emit('showMessageBar', 'the message');
 * ```
 *
 * ng Version
 * ----------
 * 1.1.5 - 1.2
 *
 */
angular.module('jv.Common.MessageBar', [])

.value('messageBarTemplateUrl', '../htm/common/messageBar.html')

.run([function() {

	var el = $('<div jv-message-bar />');
	$(document.body).append(el);

}])

.directive('jvMessageBar', ['$timeout', 'messageBarTemplateUrl', '$window', function($timeout, tplUrl, $window){

	var types = {

		success: {
		},

		error: {
			className: 'message-bar-error'
		}

	},
	timer;

	return {
		scope: {},
		replace: true,
		templateUrl: tplUrl,
		link: function($scope, iElm, iAttrs) {

			if (angular.version.major === 1 && angular.version.minor < 2) {
				// hack for angular 1.1.5 to prevent initial hide animation
				iElm.hide().removeClass('ng-hide');
			}

			var deregisterShowListener;

			$scope.hide = function() {
				$scope.show = false;
			};
			$scope.isNextGenEnabled = window.isnextGenUIEnabled && window.isnextGenUIEnabled === 'true';

			deregisterShowListener = $scope.$root.$on('showMessageBar', function(e, opts) {

				if (typeof opts !== 'object') {
					opts = {
						title: opts
					};
				}
				opts = angular.extend({}, {
					message: '',
					title: '',
					position: 'bottom',
					duration: 5000,
					className: '',
					icon: ''
				}, types.success, opts, types[opts.type] || {});

				// remove all classes except jv-message-bar and ng-hide
				iElm.removeClass(function(index, css) {
					return css.replace(/(jv\-message\-bar|ng\-.*)/g, '');
				}).addClass(opts.className);

				if (opts.message) {
					iElm.find('.jv-message-bar-body').show().html(opts.message);
				}
				else {
					iElm.find('.jv-message-bar-body').hide();
				}

				if (opts.title) {
					iElm.find('.jv-message-bar-header').show().html(opts.title);
				}
				else {
					iElm.find('.jv-message-bar-header').hide();
				}

				if (opts.icon) {
					iElm.find('.secondary').html('<span class="icon '+ opts.icon +'" />');
				}
				else {
					iElm.find('.secondary').empty();
				}
				//add default bottom class so that the message bar shows up at the bottom 
				iElm.addClass('bottom');
				
				if (opts.position =='top') {
					//add top class and remove bottom class so that the message bar shows up at the top of the page. 
					iElm.removeClass('bottom');
					iElm.addClass('top');
				}
				$scope.show = true;

				if (opts.duration) {
					$timeout.cancel(timer);
					timer = $timeout(function() {
						$scope.show = false;
					}, opts.duration);
				}

			});
			$scope.$root.$on('hideMessageBar', function() {
				$scope.hide();
			});

			$($window).on('beforeunload unload', function() {
				$scope.hide();
				deregisterShowListener();
			});
		}
	};
}]);